// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.generator-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #022423 0%, #034544 50%, #022423 100%);
  direction: rtl;
  font-family: 'Cairo', Arial, sans-serif;
  padding-bottom: 50px;
}

.generator-header {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  padding: 20px 40px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.header-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.generator-header h1 {
  color: #bba67b;
  font-size: 28px;
  font-weight: 800;
  margin: 0;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 20px;
  color: white;
  font-weight: 600;
}

.logout-button {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: 2px solid rgba(255, 255, 255, 0.3);
  padding: 8px 20px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.3s ease;
  font-family: 'Cairo', Arial, sans-serif;
}

.logout-button:hover {
  background: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.5);
}

.generator-box {
  max-width: 800px;
  margin: 50px auto;
  background: white;
  border-radius: 20px;
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.3);
  padding: 40px;
}

.generator-title {
  text-align: center;
  margin-bottom: 40px;
  padding-bottom: 30px;
  border-bottom: 3px solid #f0f0f0;
}

.generator-title h2 {
  color: #022423;
  font-size: 32px;
  font-weight: 800;
  margin-bottom: 10px;
}

.generator-title p {
  color: #666;
  font-size: 16px;
  font-weight: 600;
}

.form-section {
  display: flex;
  flex-direction: column;
  gap: 25px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.form-group label {
  color: #022423;
  font-weight: 700;
  font-size: 18px;
}

.employee-select {
  padding: 15px 20px;
  border: 2px solid #e0e0e0;
  border-radius: 10px;
  font-size: 16px;
  font-family: 'Cairo', Arial, sans-serif;
  transition: all 0.3s ease;
  background: white;
  cursor: pointer;
}

.employee-select:focus {
  outline: none;
  border-color: #bba67b;
  box-shadow: 0 0 0 3px rgba(187, 166, 123, 0.1);
}

.error-message {
  background: #ffe6e6;
  color: #c00;
  padding: 12px;
  border-radius: 8px;
  text-align: center;
  font-weight: 600;
  border: 1px solid #ffcccc;
}

.buttons-group {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-top: 10px;
}

.generate-button {
  padding: 16px;
  border: none;
  border-radius: 10px;
  font-size: 18px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: 'Cairo', Arial, sans-serif;
  color: white;
}

.generate-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.front-button {
  background: linear-gradient(135deg, #022423 0%, #034544 100%);
}

.front-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(2, 36, 35, 0.3);
}

.back-button {
  background: linear-gradient(135deg, #034544 0%, #022423 100%);
}

.back-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(3, 69, 68, 0.3);
}

.both-button {
  background: linear-gradient(135deg, #bba67b 0%, #8d7f5e 100%);
  font-size: 20px;
  padding: 18px;
}

.both-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(187, 166, 123, 0.4);
}

.instructions {
  margin-top: 40px;
  padding: 25px;
  background: #f8f9fa;
  border-radius: 10px;
  border-right: 4px solid #bba67b;
}

.instructions h3 {
  color: #022423;
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 15px;
}

.instructions ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.instructions li {
  color: #555;
  font-size: 15px;
  line-height: 1.8;
  padding-right: 20px;
  position: relative;
  margin-bottom: 8px;
}

.instructions li::before {
  content: '✓';
  position: absolute;
  right: 0;
  color: #bba67b;
  font-weight: 700;
  font-size: 18px;
}

@media (max-width: 768px) {
  .generator-box {
    margin: 20px;
    padding: 25px;
  }

  .generator-header {
    padding: 15px 20px;
  }

  .header-content {
    flex-direction: column;
    gap: 15px;
  }

  .generator-title h2 {
    font-size: 24px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/CardGenerator.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,0EAA0E;EAC1E,cAAc;EACd,uCAAuC;EACvC,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,0CAA0C;EAC1C,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,uCAAuC;EACvC,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,uCAAuC;EACvC,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,6DAA6D;EAC7D,eAAe;EACf,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".generator-container {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #022423 0%, #034544 50%, #022423 100%);\n  direction: rtl;\n  font-family: 'Cairo', Arial, sans-serif;\n  padding-bottom: 50px;\n}\n\n.generator-header {\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(10px);\n  padding: 20px 40px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);\n}\n\n.header-content {\n  max-width: 1200px;\n  margin: 0 auto;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.generator-header h1 {\n  color: #bba67b;\n  font-size: 28px;\n  font-weight: 800;\n  margin: 0;\n}\n\n.user-info {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  color: white;\n  font-weight: 600;\n}\n\n.logout-button {\n  background: rgba(255, 255, 255, 0.2);\n  color: white;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  padding: 8px 20px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: 600;\n  transition: all 0.3s ease;\n  font-family: 'Cairo', Arial, sans-serif;\n}\n\n.logout-button:hover {\n  background: rgba(255, 255, 255, 0.3);\n  border-color: rgba(255, 255, 255, 0.5);\n}\n\n.generator-box {\n  max-width: 800px;\n  margin: 50px auto;\n  background: white;\n  border-radius: 20px;\n  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.3);\n  padding: 40px;\n}\n\n.generator-title {\n  text-align: center;\n  margin-bottom: 40px;\n  padding-bottom: 30px;\n  border-bottom: 3px solid #f0f0f0;\n}\n\n.generator-title h2 {\n  color: #022423;\n  font-size: 32px;\n  font-weight: 800;\n  margin-bottom: 10px;\n}\n\n.generator-title p {\n  color: #666;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.form-section {\n  display: flex;\n  flex-direction: column;\n  gap: 25px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.form-group label {\n  color: #022423;\n  font-weight: 700;\n  font-size: 18px;\n}\n\n.employee-select {\n  padding: 15px 20px;\n  border: 2px solid #e0e0e0;\n  border-radius: 10px;\n  font-size: 16px;\n  font-family: 'Cairo', Arial, sans-serif;\n  transition: all 0.3s ease;\n  background: white;\n  cursor: pointer;\n}\n\n.employee-select:focus {\n  outline: none;\n  border-color: #bba67b;\n  box-shadow: 0 0 0 3px rgba(187, 166, 123, 0.1);\n}\n\n.error-message {\n  background: #ffe6e6;\n  color: #c00;\n  padding: 12px;\n  border-radius: 8px;\n  text-align: center;\n  font-weight: 600;\n  border: 1px solid #ffcccc;\n}\n\n.buttons-group {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  margin-top: 10px;\n}\n\n.generate-button {\n  padding: 16px;\n  border: none;\n  border-radius: 10px;\n  font-size: 18px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-family: 'Cairo', Arial, sans-serif;\n  color: white;\n}\n\n.generate-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.front-button {\n  background: linear-gradient(135deg, #022423 0%, #034544 100%);\n}\n\n.front-button:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 5px 15px rgba(2, 36, 35, 0.3);\n}\n\n.back-button {\n  background: linear-gradient(135deg, #034544 0%, #022423 100%);\n}\n\n.back-button:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 5px 15px rgba(3, 69, 68, 0.3);\n}\n\n.both-button {\n  background: linear-gradient(135deg, #bba67b 0%, #8d7f5e 100%);\n  font-size: 20px;\n  padding: 18px;\n}\n\n.both-button:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 5px 15px rgba(187, 166, 123, 0.4);\n}\n\n.instructions {\n  margin-top: 40px;\n  padding: 25px;\n  background: #f8f9fa;\n  border-radius: 10px;\n  border-right: 4px solid #bba67b;\n}\n\n.instructions h3 {\n  color: #022423;\n  font-size: 20px;\n  font-weight: 700;\n  margin-bottom: 15px;\n}\n\n.instructions ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.instructions li {\n  color: #555;\n  font-size: 15px;\n  line-height: 1.8;\n  padding-right: 20px;\n  position: relative;\n  margin-bottom: 8px;\n}\n\n.instructions li::before {\n  content: '✓';\n  position: absolute;\n  right: 0;\n  color: #bba67b;\n  font-weight: 700;\n  font-size: 18px;\n}\n\n@media (max-width: 768px) {\n  .generator-box {\n    margin: 20px;\n    padding: 25px;\n  }\n\n  .generator-header {\n    padding: 15px 20px;\n  }\n\n  .header-content {\n    flex-direction: column;\n    gap: 15px;\n  }\n\n  .generator-title h2 {\n    font-size: 24px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
